<template>
    <div>
        <div style="display: flex;justify-content: space-between;" v-if="sum">
            <div style="width: calc(33vw - 100px);text-align: center;padding: 50px 0;">
                <div>收货金额合计（元）</div>
                <div style="font-size: 20px;font-weight: bold;">{{session.permission.baobiaojiage?AmountDecimal(sum['wupin.yishouhuojinehanshui'],2):'--'}}</div>
            </div>
            <div style="width: calc(33vw - 100px);text-align: center;padding: 50px 0;">
                <div>退货金额合计（元）</div>
                <div style="font-size: 20px;font-weight: bold;">{{session.permission.baobiaojiage?AmountDecimal(sum['wupin.tuihuojinehanshui'],2):'--'}}</div>
            </div>
            <div style="width: calc(33vw - 100px);text-align: center;padding: 50px 0;">
                <div>实收金额合计（元）</div>
                <div style="font-size: 20px;font-weight: bold;">{{session.permission.baobiaojiage?AmountDecimal(sum['wupin.yishouhuojinehanshui'] - sum['wupin.tuihuojinehanshui'],2):'--'}}</div>
            </div>
        </div>
    </div>
</template>
<script>
    import { AmountDecimal } from '@/utils/price'
    export default {
        props: {
            sum: Object
        },
        data() {
            return {
                AmountDecimal,
                session: this.$store.session,
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/common/MoneyTotal/index.vue?6ef3daf2